import { useNavigate } from 'react-router-dom';
import { useGetRelatedCourtsQuery } from '../../Api/courts';
import CourtCard from '../../Components/CourtCard';
import useTranslate from '../../Hooks/useTranslate';
import Title from '../../Style-guide/Title';
import SelectCourtWrapper from './style/selectCourtWrapper';

const SelectCourt = () => {
  const { data: courtsData, isSuccess } = useGetRelatedCourtsQuery();
  const navigate = useNavigate();
  const tr = useTranslate();

  return (
    <SelectCourtWrapper>
      <Title size='LG' className='choose-court-title'>
        {tr('choose_the_court')}
      </Title>

      <section className='cards-container'>
        {isSuccess
          ? courtsData?.map((court) => (
              <CourtCard
                key={court.id}
                data={court}
                colAmount={courtsData.length}
                preview={false}
                onClick={() => navigate(`/organizers/court/${court.id}`)}
              />
            ))
          : null}
      </section>
    </SelectCourtWrapper>
  );
};

export default SelectCourt;
